module.exports = __webpack_public_path__ + "components/country-flag/static/th-280089ba51779ac616c4da32587f167a.svg";